(function () {
  if (window.__tkCardEnhance) return;
  window.__tkCardEnhance = true;

  function buildHead(card) {
    if (card.querySelector('.tk-card-head')) return;
    var title = card.querySelector('.product-card__content .text-block[class*="product_title"]')
             || card.querySelector('.product-card__content .text-block.rte');
    if (!title) return;
    var anchor = title.closest('a') || title;
    if (!anchor.parentNode) return;

    var head = document.createElement('div');
    head.className = 'tk-card-head';

    var eb = document.createElement('span');
    eb.className = 'tk-card-head__eyebrow';
    eb.textContent = card.getAttribute('data-tk-eyebrow') || '';
    head.appendChild(eb);

    var rating = parseFloat(card.getAttribute('data-tk-rating')) || 0;
    var count = parseInt(card.getAttribute('data-tk-rating-count'), 10) || 0;
    var slot = card.querySelector('.tk-card-rating');
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'tk-card-rating';
    }
    if (!slot.querySelector('.tk-stars')) {
      var stars = document.createElement('span');
      stars.className = 'tk-stars';
      if (count > 0 && rating > 0) {
        var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
        var fill = document.createElement('span');
        fill.className = 'tk-stars__fill';
        fill.style.width = pct.toFixed(1) + '%';
        fill.appendChild(document.createElement('span'));
        stars.appendChild(fill);
      }
      slot.insertBefore(stars, slot.firstChild);
    }
    if (count > 0 && !slot.querySelector('.tk-card-rating__count')) {
      var cnt = document.createElement('span');
      cnt.className = 'tk-card-rating__count';
      cnt.textContent = '(' + count + ')';
      slot.appendChild(cnt);
    }
    if (count === 0) slot.classList.add('tk-card-rating--blank');
    head.appendChild(slot);

    anchor.parentNode.insertBefore(head, anchor);
  }

  function buildMetarow(card) {
    var left = card.querySelector('.tk-card-bottom-row__left');
    if (!left) return;
    var price = left.querySelector('product-price');
    if (!price) return;
    var row = left.querySelector('.tk-card-metarow');
    if (!row) {
      row = document.createElement('div');
      row.className = 'tk-card-metarow';
      left.insertBefore(row, left.firstChild);
    }
    if (price.parentNode !== row) row.appendChild(price);
    var stock = card.querySelector('.tk-stock-badge');
    if (stock && !row.contains(stock) && !stock.closest('.tk-card-meta')) row.appendChild(stock);
  }

  function enhance(scope) {
    (scope || document).querySelectorAll('product-card.product-card').forEach(function (card) {
      buildHead(card);
      buildMetarow(card);
      card.querySelectorAll('product-price .price').forEach(function (pe) {
        if (pe.querySelector('.tk-cur')) return;
        if (pe.innerHTML.indexOf('Kč') !== -1 || pe.innerHTML.indexOf('€') !== -1) {
          pe.innerHTML = pe.innerHTML.replace(/Kč|€/g, function (m) { return '<span class="tk-cur">' + m + '</span>'; });
        }
      });
      card.classList.remove('tk-card-pending');
      card.classList.add('tk-card-ready');
    });
  }

  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; enhance(document); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  else enhance(document);
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          if (a[j].nodeType === 1) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();

(function () {
  if (window.__tkSupInfoPortal) return;
  window.__tkSupInfoPortal = true;

  var portal = null;
  var openTrigger = null;
  var clickTrigger = null;
  function ensurePortal() {
    if (portal) return portal;
    portal = document.createElement('div');
    portal.className = 'tk-supinfo-portal';
    portal.setAttribute('role', 'tooltip');
    portal.setAttribute('aria-hidden', 'true');
    document.body.appendChild(portal);
    return portal;
  }

  function show(trigger) {
    var text = trigger.getAttribute('aria-label');
    if (!text) return;
    openTrigger = trigger;
    var tip = ensurePortal();
    var host = trigger.closest('dialog[open]') || document.body;
    if (tip.parentNode !== host) host.appendChild(tip);
    tip.textContent = text;
    tip.classList.add('is-on');
    var r = trigger.getBoundingClientRect();
    var tw = tip.offsetWidth;
    var th = tip.offsetHeight;
    var cx = r.left + r.width / 2;
    var left = Math.max(8, Math.min(cx - tw / 2, window.innerWidth - tw - 8));
    var top = r.top - th - 9;
    var below = false;
    if (top < 8) { top = r.bottom + 9; below = true; }
    if (host === document.body) {
      tip.style.position = 'fixed';
    } else {
      tip.style.position = 'absolute';
      var hr = host.getBoundingClientRect();
      left -= hr.left;
      top -= hr.top;
      cx -= hr.left;
    }
    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
    tip.style.setProperty('--tk-supinfo-arrow-x', (cx - left) + 'px');
    tip.classList.toggle('is-below', below);
  }

  var parkTimer = null;
  function hide() {
    openTrigger = null;
    clickTrigger = null;
    if (!portal) return;
    portal.classList.remove('is-on');
    if (parkTimer) clearTimeout(parkTimer);
    parkTimer = setTimeout(function () {
      if (portal && !portal.classList.contains('is-on')) {
        portal.style.top = '-9999px';
        portal.style.left = '-9999px';
      }
    }, 220);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.tk-supinfo');
    if (!t) {
      if (openTrigger) hide();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (clickTrigger === t) {
      hide();
      return;
    }
    show(t);
    clickTrigger = openTrigger;
  }, true);

  document.addEventListener('mouseover', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.tk-supinfo');
    if (t) show(t);
  }, true);
  document.addEventListener('mouseout', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.tk-supinfo');
    if (t && !(e.relatedTarget && t.contains(e.relatedTarget))) hide();
  }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.tk-supinfo');
    if (t) show(t); else hide();
  }, true);
  document.addEventListener('focusout', function () { hide(); }, true);
  window.addEventListener('scroll', hide, { passive: true, capture: true });
})();

